import { useState } from "react";
import { postData as apiPostData } from "../../services/api";

const usePost = (endpoint, initialData = {}) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (postData, useFormData = false) => {
    setLoading(true);
    try {
      const response = await apiPostData(endpoint, postData, useFormData);
      setData(response.data);
      setError(null)
      return response.data;
    } catch (err) {
      setError(err);
      throw err
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postData, setError };
};

export default usePost;